import {
	IStackStyles,
	Link,
	PrimaryButton,
	Stack
} from "@fluentui/react";
import { CustomFontText } from "components/customFontText/CustomFontText";
import CustomTable from "components/table/datatable/CustomTable";
import moment from "moment";
import { Dropdown } from 'primereact/dropdown';
import { Paginator } from 'primereact/paginator';
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { DebounceInput } from 'react-debounce-input';
import { Col, Row } from "react-grid-system";
import {
	useDispatch,
	useSelector
} from "react-redux";
import { useMediaQuery } from "react-responsive";
import { useLocation, useNavigate } from "react-router-dom";
import { AppState } from "store/index";
import { handleGetLocations } from "store/locations/locations.action";
import { handleGetOneDaySaleDate, handleGetOneDaySaleWorkbook, handleSelectedOneDaySaleTradeIn } from "store/oneDaySale/oneDaySale.action";
import { currencyNegValFractionalFormat } from "utils/helperFunctions";
import { getModulePermissions, isKarlProfile, isUserMaster } from "utils/permissions/permissionsHelpers";
import masterDropdownValues from "../../constants/masterDropdownValues";
import { EditMoreActionsSubmenu } from "components/table/dropdowns/EditMoreActionsSubmenu";
import { getOneDaySaleDate, getOneDaySaleLocation, removeOneDaySaleDate, removeOneDaySaleLocation, saveOneDaySaleDate, saveOneDaySaleLocation } from "utils/localStorage/oneDaySaleFilterlocalStorage";
import { alloneDaySaleDate, dealTabIndex } from "constants/constants";
import AddCircle from "@mui/icons-material/AddCircle";
import { MultiSelect } from "primereact/multiselect";
import { convertUTCToLocalDateOnlyModified } from "utils/dateTimeFunctions";
import CloseIcon from '@mui/icons-material/Close';

const container: IStackStyles = {
	root: {
		marginTop: 10,
		minHeight: 500
	},
};

const credentialModuleName = "DealTracker";
export const OneDaySaleWorkbookPage = () => {
	const dispatch = useDispatch();
	const location = useLocation();
	const serverError = useSelector((state: AppState) => state.oneDaySale.error) as any;
	const [commonServerError, setcommonServerError] = useState(null);
	const [userProfileLoadingFlag, setUserProfileLoadingFlag] = useState(false);
	const user = useSelector((state: AppState) => state.userProfile.userProfile) as any;
	const locations = useSelector((state: AppState) => state.locations.locations) as any;
	const navigate = useNavigate();
	const [cityDealerList, setCityDealerList] = React.useState();
	const isKarlProfileType = user.profileType && isKarlProfile(user.profileType);
	const isMobile = useMediaQuery({ maxWidth: 960 });
	const [search, setGLFilter] = useState(null);
	const [locationFilter, setLocationFilter] = useState(0);
	const [primaryLocation, setPrimaryLocation] = useState(0);
	const [sortOrder, setSortOrder] = useState(null);
	const [sortField, setSortField] = useState('appraisalDate');
	const [totalRecords, setTotalRecords] = useState(null);
	const [limit, setLimit] = useState(25);
	const [pages, setPages] = useState(1);
	const [currentPage, setCurrentPage] = useState(0);
	const [loadingFlag, setLoadingFlag] = useState(false);
	const [refreshList, setRefreshList] = useState(false);
	const [filters, setFilters] = useState(null);
	const [statePageNumber, setStatePageNumber] = useState(1);
	const [saleDateFilter, setSaleDateFilter] = React.useState<Date | undefined |any>([]);
	const [statusFilter, setStatusFilter] = React.useState(null);
	const [tagFilter, setTagFilter] = React.useState(null);
	const [tableData, setTableData] = useState([]);
	const [credentials, setCredentials] = useState([]);
	const oneDaySaleDate = useSelector(
        (state: AppState) => state.oneDaySale.oneDaySaleDate
    );
	const selectedLocation = getOneDaySaleLocation();
	const selectedSaleDate = getOneDaySaleDate();

	// const isAppraiser = useMemo(() => {
	// 	const isAppraiser = user?.defaultGroups?.some(x => x.defaultGroupId === userGroupId.appraiser.key);
	// 	return isAppraiser;
	// }, [user])

	useEffect(() => {
		  if(selectedSaleDate){
			setSaleDateFilter(selectedSaleDate);
		  }
		if (selectedLocation) {
			setLocationFilter(Number(selectedLocation))
		}
	}, []) // eslint-disable-line react-hooks/exhaustive-deps


	const handleSearchChange = (event: any) => {
		const inputValue = event.target.value.trim();
		if (inputValue !== '') {
			setGLFilter(inputValue);
		}

		if (event.target.value === '') {
			setGLFilter('');
		}
	};

	const handletagChange = (event: any) => {
		const inputValue = event.target.value.trim();
		if (inputValue !== '') {
			setTagFilter(inputValue);
		}
		if (event.target.value === '') {
			setTagFilter('');
		}
	};

	const onLocationChange = (e: { value: any }) => {
		saveOneDaySaleLocation(String(e.value))
		setLocationFilter(e.value);
	}
	const onStatusChange = (e: { value: any }) => {
        setStatusFilter([...e.value]);
    }

	const onSaleDateChange = (e: { value: any }) => {
		saveOneDaySaleDate([...e.value]);
		setSaleDateFilter([...e.value]);
	}

	const fetchSaleDate = useCallback(() => {
        dispatch(
            handleGetOneDaySaleDate({
                formData: {
                    page: 1,
                    limit: 1000,
					allSaleDate:alloneDaySaleDate.allDate.key,
					column: 'oneDaySale.saleDate',
                    sort: 'DESC'
                }
            })
        );
    }, [dispatch]);

    useEffect(() => {
        fetchSaleDate();
    }, [fetchSaleDate]);


	useEffect(() => {
		if (locations && locations.results) {
			locations.results.unshift({ id: 0, legalName: 'All' });
			setCityDealerList(locations.results);
		} else {
			setCityDealerList(locations);
		}

	}, [locations]);

	useEffect(() => {
		if (user && user.roles) {
			setUserProfileLoadingFlag(true); 
			if (user.roles.some(item => item === "ROLE_EMPLOYEE") && user.primaryLocationId) {
				setPrimaryLocation(user.primaryLocationId);
				setLocationFilter(user.primaryLocationId);

			}
		}
	}, [user]);// eslint-disable-line react-hooks/exhaustive-deps

	const getStatus = (id) => {
		const data =[...masterDropdownValues.appraisalonedaySaleStatus]
		let item = data.filter(x => x.key === id);
		if (item.length === 1) {
			return item[0].text;
		}
		return '';
	};

	const getName = (person) => {
		if (person) {
			return person.firstName + ' ' + person.lastName;
		}
		return '';
	};

	const handlePopulateAppraisals = (appraisals) => {
		if (appraisals.length) {
			for (var i in appraisals) {
				let vehicle = appraisals[i].vehicle;
				let deal = appraisals[i]?.deal;
				let dealTradeInAppraisalsInfo = appraisals[i].dealTradeInAppraisals ? appraisals[i].dealTradeInAppraisals.at(-1) : null;
				appraisals[i]["appraisalDate"] = moment(appraisals[i].createdAt).local().format('MM/DD/YY hh:mm a');
				appraisals[i]["rollBack"] = dealTradeInAppraisalsInfo && currencyNegValFractionalFormat(dealTradeInAppraisalsInfo.rollback);
				 appraisals[i]["year"] = vehicle && vehicle?.year;
				 appraisals[i]["model"] = vehicle && vehicle?.model;
				 appraisals[i]["make"] = vehicle && vehicle?.make;
				 appraisals[i]["vin"] = vehicle && vehicle?.vin;
				 appraisals[i]["bidder"] = appraisals[i].appraisalBidder?.name;
				appraisals[i]["appraisalStatus"] = getStatus(appraisals[i].status);
				appraisals[i]["wholeSeller"] = getName(appraisals[i].lastAppraiser);
				appraisals[i]["appraiser"] = getName(appraisals[i]?.lastAppraiser);
				appraisals[i]["dealNumber"] = deal ? deal?.dealNumber:'';

			}
			return appraisals;
		}
		return []

	};

	const appraisalList = (isFilterApplied) => {
		
		const formData = {
			page: isFilterApplied ? statePageNumber : pages,
			limit,
			sort: sortOrder === 1 ? 'DESC' : 'ASC',
			column: sortField,
			locationId: locationFilter ? locationFilter : "",
			saleDateFilter:saleDateFilter?saleDateFilter:"",
			tagFilter:tagFilter?tagFilter:"",
			statusFilter:statusFilter?statusFilter:"",
			search: search
		};
		setFilters(formData);
		if (isFilterApplied && statePageNumber > 1) {
			setStatePageNumber(1);
		}

		dispatch<any>(handleGetOneDaySaleWorkbook({
			formData,
			callback: (response,error) => {
				
				if (response) {
					setTotalRecords(response.totalItems);
					const appraisalData = handlePopulateAppraisals(response.results);
					setTableData(appraisalData);
				} else {
					setTotalRecords(0);
					setcommonServerError('Failed to Fetch the Data.');
					setTableData([]);
				}
			}
		}));
	}
	
	const MINUTE_MS = 300000;

	useEffect(() => {
		setSortOrder(1);
		getAppraisal();
		setSortField('appraisalDate');
		if (user && user.auths && !isUserMaster(user.roles)) {
			setCredentials(getModulePermissions(user.auths, credentialModuleName));
		}
		dispatch<any>(handleGetLocations());
		 const interval = setInterval(() => {
		 	setRefreshList(true);
		 }, MINUTE_MS);
		 return () => clearInterval(interval);

	}, []); // eslint-disable-line react-hooks/exhaustive-deps

	const handleResetWorkbook = () => {
		setGLFilter("");
		setTagFilter("");
		setStatusFilter(null);
		setSaleDateFilter(null);
		setLocationFilter(primaryLocation);
		setSortOrder(1);
		setLimit(25);
		setPages(1);
		setSortField('appraisalDate');
		removeOneDaySaleLocation();
        removeOneDaySaleDate();
	};

	useEffect(() => {
		if (refreshList) {
			
			appraisalList(true)
			setRefreshList(false);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [refreshList]);


	const exportExcel = () => {
		const formData = { ...filters };
		formData.page = 1;
		formData.limit = 10000;
		formData.sort = sortOrder === 1 ? 'DESC' : 'ASC';
		dispatch<any>(handleGetOneDaySaleWorkbook({
			formData,
			callback: (response) => {
				if (response) {
					if (response && response.results) {
						let list = response.results
						const exportData = list.map((item,index) =>
						{
							let dealTradeInAppraisalsInfo = item?.dealTradeInAppraisals ? item.dealTradeInAppraisals.at(-1) : null;
							return ({
							"Appraisal Date": moment(item.createdAt).local().format('MM/DD/YY hh:mm a'),
							"Tag #": item?.tag,
							"Year": item?.vehicle?.year,
							"Make": item?.vehicle?.make,
							"Model": item?.vehicle?.model,
							"Vin": item?.vehicle ? item.vehicle.vin : "",
							"Odo": item?.odo,
							"Color": item?.color,	
							"Rollback": dealTradeInAppraisalsInfo?.rollback && currencyNegValFractionalFormat(dealTradeInAppraisalsInfo.rollback),
							// "Rollback": (isAppraiser && !item?.deal?.dealNumber ) ? "":dealTradeInAppraisalsInfo && currencyNegValFractionalFormat(dealTradeInAppraisalsInfo.rollback),
							"Top Bid": item?.appraisalBidder?.name,
							"wholeSeller": item?.lastAppraiser ?getName(item.lastAppraiser):'',
							"Deal #": item?.deal?.dealNumber,
							"status": getStatus(item?.status ? item.status : "")
						})});

						import('xlsx').then(xlsx => {
							const worksheet = xlsx.utils.json_to_sheet(exportData);
							const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
							const excelBuffer = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
							saveAsExcelFile(excelBuffer, 'one-day-sale-workbook');
						});

					}
				} else {
					setTotalRecords(0);
					setcommonServerError('Failed to Fetch the Data.');
				}
			}
		}));
	}

	const saveAsExcelFile = (buffer, fileName) => {
		import('file-saver').then(module => {
			if (module && module.default) {
				let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
				let EXCEL_EXTENSION = '.xlsx';
				const data = new Blob([buffer], {
					type: EXCEL_TYPE
				});

				module.default.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
			}
		});
	}
	
	const handleSaleDateSelectAllChange = (e) => {
		if (e.target.checked) {
			const status = saleDateOptions.map(option => option.key);
		    setSaleDateFilter(status);
		} else {
			setSaleDateFilter([]);
		}
	};

	const customSaleDateHeader = () => (
		<div className="statusFilterHeader">
			<div className="p-d-flex" style={{display:'flex'}}>
				<input
					type="checkbox"
					checked={saleDateFilter?.length === saleDateOptions?.length}
					onChange={handleSaleDateSelectAllChange}
					style={{ marginRight: '15px' }}
				/>
				<div style={{ marginTop: '-1px' }}><span>All</span></div>
				
			</div>
			<div onClick={() => setSaleDateFilter([])}>
				<CloseIcon
					className="close-icon-multiselect plus-icon svgPlus-icon" />
			</div>
		</div>
	);


	const saleDateOptions =useMemo(()=>{
		const result = oneDaySaleDate?.results?.results.map(item => ({
			key: item.id,
			text: convertUTCToLocalDateOnlyModified(item.saleDate)
		}));
		if(result?.length){
			return result;
		}else{
			return [];
		}
	},[oneDaySaleDate])

	const handleStatusSelectAllChange = (e) => {
		if (e.target.checked) {
			const status = masterDropdownValues.appraisalonedaySaleStatus.map(option => option.key);
		    setStatusFilter(status);
		} else {
			setStatusFilter([]);
		}
	};

	const customStatusHeader = () => (
		<div className="statusFilterHeader">
			<div className="p-d-flex" style={{display:'flex'}}>
				<input
					type="checkbox"
					checked={statusFilter?.length === masterDropdownValues.appraisalonedaySaleStatus?.length}
					onChange={handleStatusSelectAllChange}
					style={{ marginRight: '15px' }}
				/>
				<div style={{ marginTop: '-1px' }}><span>All</span></div>
				
			</div>
			<div onClick={() => setStatusFilter([])}>
				<CloseIcon
					style={{ color: "#7d848b", marginRight: '2px' }}
					className="plus-icon svgPlus-icon" />
			</div>
		</div>
	);

	const header = (
		<>

			{isMobile ?
				<div>
					<Row>
						<Col>
							<Row>
								<Col>
									<div className="locationDropPosition">
										<label className="lbl-text">Search</label>
										<div className="ms-TextField-fieldGroup debounce-input-group">
											<DebounceInput
												minLength={1}
												className="ms-TextField-field"
												value={search}
												debounceTimeout={750}
												onChange={(e) => handleSearchChange(e)} />
										</div>
									</div>
								</Col>
								<Col>
									<div className="locationDropPosition">
										<label className="lbl-text" style={{ paddingBottom: "0px" }}>Location</label>
										<Dropdown
											id="legalName"
											placeholder=""
											value={locationFilter}
											options={cityDealerList}
											onChange={onLocationChange}
											optionLabel="legalName"
											optionValue="id"
											appendTo="self"
											className="custom-p-dropdown"
											filter={false}
											resetFilterOnHide={true}
										/>
									</div>
								</Col>

								<Col>
									<div className="multiSelectBorder locationDropPosition">
										<label className="lbl-text" style={{ paddingBottom: "0px" }}>Status</label>
										<MultiSelect
											value={statusFilter}
											options={masterDropdownValues.appraisalonedaySaleStatus}
											// style={{ minWidth: "175px" }}
											onChange={onStatusChange}
											placeholder="Select Status"
											optionLabel="text"
											optionValue="key"
											className="saleMultiSelectDropDown multiSelectBorder custom-p-dropdown"
											maxSelectedLabels={2}
											panelHeaderTemplate={customStatusHeader}
										/>
									</div>
								</Col>
							</Row>
							<Row>
								<Col>
									<div className="multiSelectBorder locationDropPosition">
										<label className="lbl-text" style={{ paddingBottom: "0px" }}>One Day Sale Date</label>
										<MultiSelect
											value={saleDateFilter}
											options={saleDateOptions?.length ? saleDateOptions : []}
											// style={{ minWidth: "175px" }}
											onChange={onSaleDateChange}
											placeholder="Select Sale Date"
											optionLabel="text"
											optionValue="key"
											className="saleMultiSelectDropDown multiSelectBorder custom-p-dropdown"
											maxSelectedLabels={2}
											panelHeaderTemplate={customSaleDateHeader}
										/>
									</div>
								</Col>
								<Col>
									<div className="locationDropPosition">
										<label className="lbl-text">Tag #</label>
										<div className="ms-TextField-fieldGroup debounce-input-group">
											<DebounceInput
												minLength={1}
												className="ms-TextField-field"
												value={tagFilter}
												debounceTimeout={750}
												onChange={(e) => handletagChange(e)} />
										</div>
									</div>
								</Col>
								<Col className=" employeeeSearchLabelText" style={{ marginTop: "32px", maxWidth: "40%" }} >
									<PrimaryButton style={{ float: "right" }}
										onClick={handleResetWorkbook}
									>
										Reset
									</PrimaryButton>
								</Col>
							</Row>
							<Row>
								<Col className="display-row" style={{ marginTop: "15px" }}>
									{
										totalRecords !== null && <label className="lbl-text">Record Count: {tableData.length}</label>
									}
									<Link className="workbook-export-btn-mob" color="inherit" onClick={exportExcel} data-pr-tooltip="XLS"  >
										Export to Excel
									</Link>
								</Col>
							</Row>
						</Col>
					</Row>
				</div> :
				<div>
					<div>
						<Row>
							<Col md={10}>
								<Row>
									<Col md={3}>
										<div className="table-header employeeeSearchLabelText">
											<label className="lbl-text">Search</label>
											<div className="ms-TextField-fieldGroup debounce-input-group">
												<DebounceInput
													minLength={1}
													className="ms-TextField-field"
													value={search}
													debounceTimeout={750}
													onChange={(e) => handleSearchChange(e)} />
											</div>
										</div>
									</Col>
									<Col md={2}>
										<div className="dd-control">
											<label className="lbl-text">Location</label>
											<Dropdown
												id="locationId"
												placeholder=""
												value={locationFilter}
												options={cityDealerList}
												onChange={onLocationChange}
												optionLabel="legalName"
												optionValue="id"
												appendTo="self"
												className="custom-p-dropdown write-ups-location-dd"
												filter={false}
												resetFilterOnHide={true}
											/>
										</div>
									</Col>
									<Col md={2}>
										<div style={{width:'100%'}} className="multiSelectBorder">
											<label className="lbl-text" style={{ paddingBottom: "0px" }}>Status</label>
											<MultiSelect
											    style={{width:'100%'}}
												value={statusFilter}
												options={masterDropdownValues.appraisalonedaySaleStatus}
												// style={{ minWidth: "175px" }}
												onChange={onStatusChange}
												placeholder="Select Status"
												optionLabel="text"
												optionValue="key"
												className="saleMultiSelectDropDown multiSelectBorder custom-p-dropdown"
												maxSelectedLabels={2}
												panelHeaderTemplate={customStatusHeader}
											/>
										</div>
									</Col>
									<Col md={2}>
										<div style={{width:'100%'}} className="multiSelectBorder">
											<label className="lbl-text" style={{ paddingBottom: "0px" }}>One Day Sale Date</label>
											<MultiSelect
											    style={{width:'100%'}}
												value={saleDateFilter}
												options={saleDateOptions?.length ? saleDateOptions:[]}
												onChange={onSaleDateChange}
												placeholder="Select Sale Date"
												optionLabel="text"
												optionValue="key"
												className="saleMultiSelectDropDown multiSelectBorder custom-p-dropdown"
												maxSelectedLabels={2}
												panelHeaderTemplate={customSaleDateHeader}
											/>
										</div>
									</Col>
									<Col md={2}>
										<div className="table-header employeeeSearchLabelText">
											<label className="lbl-text">Tag #</label>
											<div className="ms-TextField-fieldGroup debounce-input-group">
												<DebounceInput
													minLength={1}
													className="ms-TextField-field"
													value={tagFilter}
													debounceTimeout={750}
													onChange={(e) => handletagChange(e)} />
											</div>
										</div>
									</Col>
									<Col md={1} >
										<div className="table-header employeeeSearchLabelText" style={{ marginTop: "24px" }}>
											<PrimaryButton
												onClick={handleResetWorkbook}
											>
												Reset
											</PrimaryButton>
										</div>

									</Col>
								</Row>
							</Col>
							<Col>
							</Col>
						</Row>
					</div>
					<div className="display-row total-export-row">
						<div>
							{
								totalRecords !== null && <label className="lbl-text">Record Count: {tableData.length}</label>
							}
						</div>
						<div>
							<Link className="workbook-export-btn" color="inherit" onClick={exportExcel} data-pr-tooltip="XLS"  >
								Export to Excel
							</Link>
						</div>
					</div>
				</div>}

		</>
	);

	const onPageChange = (event) => {
		setCurrentPage(event.first);
		setPages(event.page + 1);
		setLimit(event.rows);
	}

	const footer = (
		<>
			<Paginator first={currentPage} rows={limit} totalRecords={totalRecords} rowsPerPageOptions={[25, 50, 100]} onPageChange={onPageChange}></Paginator>
		</>
	);


	const bidderBodyTemplate = (rowData) => {
		return (
			<React.Fragment>
				<span className="p-column-title">Top Bid</span>
				{rowData.appraiser ? rowData.bidder : <span style={{ color: "#AF2B01" }}> {rowData.bidder} </span>}
			</React.Fragment>
		);
	};


	const statusBodyTemplate = (rowData) => {
		return (
			<React.Fragment>
				<span className="p-column-title">Status</span>
				{rowData.appraiser ? rowData.appraisalStatus : <span style={{ color: "#AF2B01" }}> {rowData.appraisalStatus} </span>}
			</React.Fragment>
		);
	};

	const appraisalDateBodyTemplate = (rowData) => {
		return (
			<React.Fragment>
				<span className="p-column-title">Appraisal Date</span>
				{rowData.appraiser ?
					rowData.appraisalDate :
					<span style={{ color: "#AF2B01" }}> {rowData.appraisalDate} </span>}
			</React.Fragment>
		);
	};

	const tagBodyTemplate = (rowData) => {
		return (
			<React.Fragment>
				<span className="p-column-title">Tag #</span>
				{rowData.tag}
			</React.Fragment>
		);
	};

	const odoBodyTemplate = (rowData) => {
		return (
			<React.Fragment>
				<span className="p-column-title">Odo</span>
				{rowData.appraiser ? rowData.odo : <span style={{ color: "#AF2B01" }}> {rowData.odo} </span>}
			</React.Fragment>
		);
	};

	const colorBodyTemplate = (rowData) => {
		return (
			<React.Fragment>
				<span className="p-column-title">Color</span>
				{rowData.appraiser ? rowData.color : <span style={{ color: "#AF2B01" }}> {rowData.color} </span>}
			</React.Fragment>
		);
	};

	const wholeSellerBodyTemplate = (rowData) => {
		return (
			<React.Fragment>
				<span className="p-column-title">WholeSaler</span>
				{rowData.appraiser ? rowData.wholeSeller : <span style={{ color: "#AF2B01" }}> {rowData.wholeSeller} </span>}
			</React.Fragment>
		);
	};

	const vinBodyTemplate = (rowData) => {
		return (
			<React.Fragment>
				<span className="p-column-title">Vin</span>
				{rowData.vin}
			</React.Fragment>
		);
	};

	const dealBodyTemplate = (rowData) => {
		return (
			<React.Fragment>
				<span className="p-column-title">Deal #</span>
				{rowData.deal?.dealNumber}
			</React.Fragment>
		);
	};

	const yearBodyTemplate = (rowData) => {
		return (
			<React.Fragment>
				<span className="p-column-title">Year</span>
				{rowData.year}
			</React.Fragment>
		);
	};

	const makeBodyTemplate = (rowData) => {
		return (
			<React.Fragment>
				<span className="p-column-title">Make</span>
				{rowData.make}
			</React.Fragment>
		);
	};

	const modelBodyTemplate = (rowData) => {
		return (
			<React.Fragment>
				<span className="p-column-title">Model</span>
				{rowData.model}
			</React.Fragment>
		);
	};

	const rollBackBodyTemplate = (rowData) => {
		return (
			<React.Fragment>
				<span className="p-column-title">Rollback</span>
				{rowData.rollBack}
				{/* {(isAppraiser && !rowData?.deal?.dealNumber )?'': rowData.rollBack}  */}
			</React.Fragment>
		);
	};

	const settingBodyTemplate = (rowData) => {
		return (
			<React.Fragment>
				{/*<span className="p-column-title" style={{ float: "left" }}>Actions</span>*/}
				{ user.roles && (
					<EditMoreActionsSubmenu
						modulePermissions={credentials}
						itemId={rowData.id}
						onEdit={() => handleEdit(rowData)}
					/>
				)}
			</React.Fragment>
		);
	};

	const handleEdit = (event) => {
			if (event.deal?.id) {
				const state = {
					pathfrom: window.location.pathname,
					tabIndex: dealTabIndex.tradeIns.key
				}
				navigate(`/${event.deal.id}/dealtracker`, { state });
			}else{
				handleNavigateToTradeIns(event?.id);
			}
		
	};

	const handleRowClick = (event) => {
		let target = event.originalEvent.target;
		if (target.nodeName === 'TD' && target.hasChildNodes() && target.lastElementChild.nodeName === 'BUTTON') {
			target?.lastElementChild?.lastElementChild?.firstElementChild.click();
		} else {
			if (event.data?.deal?.id) {
				const state = {
					pathfrom: window.location.pathname,
					tabIndex: dealTabIndex.tradeIns.key
				}
				navigate(`/${event.data.deal.id}/dealtracker`, { state });
			}else{
				handleNavigateToTradeIns(event.data.id);
			}
		}
	};

	const handleNavigateToTradeIns = (id) => {
		const state = {
			search,
			pathfrom: '/one_day_sale_workbook',
			productId: `${id}`,
			workbookName: 'onedaysaleworkbook',
			sortOrder,
			sortField,
			pages,
			limit,
			locationFilter,
			statusFilter,
			saleDateFilter,
			tagFilter
		}
		navigate(`/one_day_sale_appraisal/${id}`, { state });
	}

	useEffect(() => {
		const stateVal: any = location?.state
		if (stateVal?.searchInput) {
			setGLFilter(stateVal.searchInput);
		}
		if (stateVal?.fromKeymetrics) {
			setLocationFilter(stateVal?.locationId);
		}

		if (stateVal?.locationFilter) {
			setLocationFilter(stateVal?.locationFilter);
		}

		if (stateVal?.saleDateFilter) {
			setSaleDateFilter(stateVal?.saleDateFilter);
		}

		if (stateVal?.statusFilter) {
			setStatusFilter(stateVal?.statusFilter);
		}

		if (primaryLocation === 0 && stateVal?.locationFilter === 0) {
			setLocationFilter(0);
		}



		if (stateVal?.sortField) {
			setSortField(stateVal.sortField);
			setSortOrder(stateVal.sortOrder);
			setPages(stateVal.pages);
			setLimit(stateVal.limit);
			if (stateVal.pages > 1) {
				setStatePageNumber(stateVal.pages);
				setCurrentPage((stateVal.pages - 1) * stateVal.limit);
			}
		}
		if (stateVal?.search) {
			setGLFilter(stateVal.search)
		}
		if (stateVal?.tagFilter) {
			setTagFilter(stateVal.tagFilter)
		}

		//setStatesFlag(true);
		setLoadingFlag(true);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [location]);

	useEffect(() => {
		if (serverError) {
			if (serverError.detail) {
				setcommonServerError(serverError.detail);
			} else {
				setcommonServerError('Something went wrong');
			}
			window.scrollTo(0, 0);
		} else {
			setcommonServerError(null);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [serverError]);

	const table_columns = {
		"appraisalDate": "Appraisal Date",
		"tag": "Tag #",
		"year": "Year",
		"make": "Make",
		"model": "Model",
		"odo": "Odo",
		"color": "Color",
		"rollBack": "RollBack",
		"topbid": "Top Bid",
		"wholeSeller": "WholeSeller",
		"vin": "Vin",
		"deal": "Deal #",
		"status": "Status",
		"settings": "Actions"
	}

	const handleColumnSort = (e) => {
		setSortField(e.sortField);
		setSortOrder(e.sortOrder);
	}

	const getAppraisal = (isFilterApplied = false) => {
		
		setcommonServerError('');
		if (loadingFlag && userProfileLoadingFlag) {
			appraisalList(isFilterApplied)
		}
	}

	useEffect(() => {
		if (statePageNumber > 1) {
			setPages(statePageNumber);
		} else {
			setPages(1);
			setCurrentPage(0);
		}
		
		getAppraisal(true);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [search, locationFilter,statusFilter, tagFilter,loadingFlag, userProfileLoadingFlag,saleDateFilter]);

	useEffect(() => {
		getAppraisal();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [limit, pages, sortOrder, sortField]);


	const handleNavigateToAppraisal = () => {
		dispatch<any>(handleSelectedOneDaySaleTradeIn({}));
		const state = {
			search,
			pathfrom: '/one_day_sale_workbook',
			workbookName: 'onedaysaleworkbook',
			sortOrder,
			sortField,
			pages,
			limit,
			locationFilter,
			statusFilter,
			saleDateFilter,
			tagFilter
		}
		navigate(`/one_day_sale_appraisal`, { state });
	}
	
	return (
		isKarlProfileType ? <>
			<Stack styles={container} tokens={{ childrenGap: 10 }}>
				<Stack
					horizontal
					verticalAlign="center"
					horizontalAlign="space-between"
					className="loc_btn_par_con"
				>
					<Row>
						<Col className="alignHeaders" style={{ display: "flex" }}>
							<CustomFontText className="pageTitleFont pageName pageHeaderFont">One Day Sale Appraisals</CustomFontText>
							<div style={{margin:'20px 20px 0px 0px'}} >
							<Link
								color="inherit"
								style={{ fontSize: "16px" }}
                                onClick={()=>{handleNavigateToAppraisal()}}
							>
								<AddCircle
									style={{ color: "#70af60",marginRight:'2px' }}
									className="plus-icon svgPlus-icon" />
								Add Appraisal
							</Link>
							</div>
						</Col>
					</Row>
				</Stack>
				{
					commonServerError ?
						<div>
							<p className="genericErrorColor"><span>{commonServerError}</span></p>
						</div> : null
				}
				<div className="datatable-filter-demo noMaxWidthTable trade-in-workbook">
					<div className="lazy-loading-workbook card">
						<CustomTable
							column_list={table_columns}
							data={tableData}
							header={header}
							footer={footer}
							lazy
							sortField={sortField}
							paginator={false}
							sortOrder={sortOrder}
							onSort={handleColumnSort}
							customTemplates={{
								"appraisalDate": appraisalDateBodyTemplate,
								"Tag #": tagBodyTemplate,
								"year": yearBodyTemplate,
								"make": makeBodyTemplate,
								"model": modelBodyTemplate,
								"odo": odoBodyTemplate,
								"color": colorBodyTemplate,
								"rollBack": rollBackBodyTemplate,
								"topbid": bidderBodyTemplate,
								"wholeSeller": wholeSellerBodyTemplate,
								"vin": vinBodyTemplate,
								"deal": dealBodyTemplate,
								"status": statusBodyTemplate,
								"settings": settingBodyTemplate,
							}}
							emptyMessage="No appraisals found."
							onRowClick={(event) => handleRowClick(event)}
						/>
					</div>
				</div>
			</Stack>
		</> : null
	);
};


